import { Grid } from "@material-ui/core";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import banner from "../images/banner.jpg";
import * as data from '../Data'
import { getCookie } from 'typescript-cookie'
import { Link } from "react-router-dom";
import { Member } from "../interfaces/Member";
import { useEffect, useState } from "react";
import image1 from '../images/image_1.jpg';
import image2 from '../images/image_2.jpg';
import image3 from '../images/image_3.jpg';
import logo from '../images/epic-logo.png';

export function HiltonHeadIslandAdvantageEmbarc() {
    const [owner, setOwner] = useState<Member>();
    const [sorLink, setSorLink] = useState('');

    useEffect(() => {
        const ownerCookie = getCookie('owner') || undefined;

        if (ownerCookie) {
            setOwner(JSON.parse(ownerCookie) as Member);
            const member = JSON.parse(ownerCookie) as Member;

            const getSorLink = async () => {
                const memberWithSorLink = await data.partnerLogin(
                    member,
                    (member) => {
                        setSorLink(member.sorLink);
                    },
                    (error) => {
                        console.log(error);
                    })
            }

            getSorLink();

        } else {
            window.location.href = "/login";
        }
    }, [])

    const visitPartner = (url: string) => {
        const partnerModal = document.getElementById('partner-modal') || undefined;
    
        if (partnerModal) {
            partnerModal.style.display = 'block';
    
        }
    
        const partnerLink = document.getElementById('partner-link') as HTMLAnchorElement || undefined;
    
        if (partnerLink) {
            partnerLink.href = url;        
        } else {
            console.log('no partnerLink');
        }
    
    }

    const removeModal = () => {
        const partnerModal = document.getElementById('partner-modal') || undefined;
    
        if (partnerModal) {
            partnerModal.style.display = 'none';
    
        }
    }

    return (
        <div>

            {owner && <Header owner={owner} partnerLink={() => visitPartner(sorLink)} />}

            {owner &&
                    <div id='partner-modal' style={{ display: 'none' }}>
                    <div style={{ position: 'fixed', top: '0', left: '0', backgroundColor: 'black', opacity: '.6', zIndex: '1', width: '100vw', height: '100vh' }}>
                    </div>
                    <div className="modal-solid">
                        <div className="modal-content-solid">
                            <div style={{ width: '100%', textAlign: 'center' }}><img style={{ width: "30%", margin: '30px 10px 10px 10px' }} src={logo} alt='Epic Logo' /></div>
                            <div style={{ margin: '30px', fontSize: '1.1em' }}>
                                You are about to visit one of our travel partner's website. The partner website will open in a new tab in your browser. To return to the Member Portal, please click on this tab or close the partner website tab.
                            </div>
                            <div style={{ width: '100%', textAlign: 'center' }}>
                                <a id='partner-link' onClick={ removeModal } href='#' style={{ color: 'white' }} target='_blank'><button style={{
                                    margin: '20px 0px',
                                    padding: '10px 20px',
                                    backgroundColor: '#031d42',
                                    width: '50%',
                                    border: '0px solid',
                                    borderRadius: '8px',
                                    color: 'white',
                                    fontFamily: 'Assistant',
                                    fontWeight: '500',
                                    fontSize: '1.2em'
                                }} >Continue</button></a>
                            </div>
                        </div>
                    </div>
                </div>
                }

            {owner &&
            <div>
                <Grid container>
                    <Grid item xs={12}>
                        <div style={{ width: '100%', margin: '0px' }}>
                            <img src={banner} style={{ width: '100%' }} alt='beach scene' />
                        </div>
                        <div style={{
                            fontSize: '2.5em',
                            fontFamily: 'Assistant',
                            fontWeight: 'bold',
                            width: '100%',
                            textAlign: 'center',
                            margin: '10px'
                        }}>
                            Hilton Head Island Advantage
                        </div>
                    </Grid>
                </Grid>
                
                <Grid container style={{ marginBottom: '60px' }}>
                    <Grid item xs={12}>
                        <div style={{
                            margin: 'auto',
                            width: '60%',
                            lineHeight: '130%',
                            fontSize: '1.15em',
                            textAlign: 'center'
                        }}>
                            <div className='tier-label'>Island Insider</div>
                            <div>Live like a local and vacation like a VIP with Island Insider by Epic Vacations.
                                 Members enjoy exclusive access to deeply discounted Hilton Head vacation rentals plus unbeatable perks 
                                 like complimentary greens fees, dining deals, and discounts on island adventures. From luxury stays to 
                                 unforgettable experiences, Island Insider gives you more of Hilton Head for less.</div>
                            <div className='tier-label'>Hilton Head Island Access</div>
                            <div className='tier-sub-label'>Studios and One Bedroom Villas</div>
                            <div>$450<sup>*</sup> per week</div>
                            <div className='tier-sub-label'>Two Bedroom Villas and Townhomes</div>
                            <div>$550<sup>*</sup> per week</div>
                            <div className='tier-sub-label'>Two Bedroom w/ Loft and Three Bedroom Villas</div>
                            <div>$650<sup>*</sup> per week</div>
                            <div>Send your requests to <a href="mailto:membercare@myepicvacations.com">membercare@myepicvacations.com</a> and start planning your perfect island getaway.</div>
                            <div className='tier-footnote'>* Based on availability. Subject to black-out dates and holidays. Valid booking window is 60 days prior to check-in date.<br />Taxes and fees not included. Pricing subject to change at any time.</div>
                            <div className='tier-label'>Hilton Head Island Partner Rentals</div>
                            <div>Want even more choices? Members also receive access and discounted pricing on other <b>Hilton Head vacation rentals</b> through our trusted partners.</div>
                            <div><a href="https://www.mywebrez.com/epicvacations" target="blank">Search and Book Here</a></div>
                        </div>
                    </Grid>
                </Grid>
            </div>
            }

            {owner && <Footer />}
        </div>
    )
}